<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Inicio</a></li>
                <li><a routerLink="/afiliados-listado">Listado de Afiliados</a></li>
                <li>Modificar Afiliado</li>
            </ul>
            <h2>Modificar Afiliado</h2>
            <h2 *ngIf="usuario">{{usuario?.nombrePersona}} {{usuario?.apellidoPersona}}</h2>
        </div>
    </div>
</div>

<app-loading *ngIf="!flagLoaded"
             class="m-5"></app-loading><br>
              
<div class="andorra-apply-content ptb-70  animate__animated animate__fadeIn">
    <div class="container"
         *ngIf="flagLoaded">
        <div class="profile-courses-quizzes">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="apply-form">
                        <div class="card-header">
                            <h3 class="text-center text-info"
                                *ngIf="usuario">
                                {{usuario?.nombrePersona}} {{usuario?.apellidoPersona}}</h3>
                        </div>
                        <br>
                        <mat-progress-bar *ngIf='flagProcesando'
                                          mode="indeterminate"></mat-progress-bar>
                        <br>

                          <div>
                            <button (click)="mostrarDatosSidefi()" class="btn btn-primary">Mostrar Datos Sidefi</button>
                          </div>

                         <br>

                          
                          <div *ngIf="mostrarCard">
                            <div class="card">
                              <div class="card-header">
                                DATOS SIDEFI
                              </div>
                              <div class="card-body">
                                <div *ngIf="flagSidefiLoading">
                                  <p>Consultando afiliado...</p>
                                </div>
                                <div *ngIf="!flagSidefiLoading && dataSidefi">
                                  <ul>
                                    <li><strong>Nombre:</strong> {{ dataSidefi.nombre }}</li>
                                    <li><strong>Fecha Afiliado MT:</strong> {{ dataSidefi.fecAfiliadoMT }}</li>
                                    <li><strong>Fecha Afiliado SD:</strong> {{ dataSidefi.fecAfiliadoSD }}</li>
                                    <li><strong>Fecha Afiliado OS:</strong> {{ dataSidefi.fecAfiliadoOS }}</li>
                                    <li><strong>Sede:</strong> {{ dataSidefi.sedeAfiliado || 'No informada' }}</li>
                                  </ul>
                                </div>
                                <div *ngIf="!flagSidefiLoading && !dataSidefi">
                                  <p>No se encontraron datos para el DNI ingresado.</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                        <ngx-tabset>
                            <ngx-tab tabTitle="Información Básica">
                                <form [formGroup]="formAfiliado"
                                      (ngSubmit)="onSubmit()">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-6">

                                            <div class="form-group"
                                                 [class.required]="true">
                                                <label>Nombre</label>
                                                <input formControlName="nombre"
                                                       type="text"
                                                       [placeholder]="'Nombre'"
                                                       class="form-control uppercase"
                                                       [class.is-invalid]="nombre"
                                                       required>
                                                <mat-error *ngIf="nombre"
                                                           class="text-danger">Ingrese un nombre</mat-error>
                                            </div>

                                            <div class="form-group"
                                                 [class.required]="true">
                                                <label>Apellido</label>
                                                <input formControlName="apellido"
                                                       type="text"
                                                       [placeholder]="'Apellido'"
                                                       class="form-control uppercase"
                                                       [class.is-invalid]="apellido"
                                                       required>
                                                <mat-error *ngIf="apellido"
                                                           class="text-danger">Ingrese un
                                                    apellido</mat-error>
                                            </div>

                                            <div class="form-group"
                                                 [class.required]="true">
                                                <mat-form-field appearance="fill">
                                                    <label for="tipoIdentificacion">Tipo Identificación</label>
                                                    <mat-select formControlName="tipoIdentificacion"
                                                                (ngModelChange)="onChangeTipoIdentificacion($event);">
                                                        <mat-option *ngFor="let ti of tiposIdentificaciones"
                                                                    value="{{ti.concepto}}"
                                                                    [class.is-invalid]="tipoIdentificacion">{{ti.concepto}}
                                                        </mat-option>
                                                        <mat-error *ngIf="tipoIdentificacion"
                                                                   class="text-danger">Ingrese un tipo de
                                                            identificación</mat-error>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                            <div class="form-group"
                                                 [class.required]="true">
                                                <label>Número de Identificación - D.N.I</label>
                                                <input formControlName="identificacion"
                                                       type="text"
                                                       [placeholder]="'Número de Identificación - D.N.I'"
                                                       class="form-control"
                                                       [class.is-invalid]="identificacion">
                                                <mat-error *ngIf="identificacion"
                                                           class="text-danger">Ingrese una
                                                    identificación</mat-error>
                                                <div *ngIf="this.flagExisteIdentificacion">
                                                    <mat-error class="text-danger">Su identificación ya existe en el sistema</mat-error>
                                                    <div class="p-3 mb-2 bg-primary text-white">Su identificación tiene asociada otra cuenta de email. Debe ponerse en contacto con el adminsitrador del sistema, para poder validar su identidad y continuar la solicitud</div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <mat-form-field appearance="fill">
                                                    <label for="estadoCivilDataList"
                                                           class="form-label">Estado Civil</label>
                                                    <mat-select formControlName="estadoCivil"
                                                                (ngModelChange)="onChangeEstadoCivil($event)">
                                                        <mat-option *ngFor="let estadoCivil of estadosCiviles"
                                                                    value="{{estadoCivil.concepto}}">{{estadoCivil.concepto}}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                        </div>

                                        <div class="col-lg-6 col-md-6">

                                            <div class="form-group"
                                                 [class.required]="true">
                                                <label>Fecha de nacimiento</label>
                                                <input formControlName="birth"
                                                       type="date"
                                                       class="form-control"
                                                       [placeholder]="'Fecha de nacimiento'"
                                                       [class.is-invalid]="birth"
                                                       required>
                                                <mat-error *ngIf="birth"
                                                           class="text-danger">Ingrese la fecha de
                                                    nacimiento</mat-error>
                                            </div>

                                            <div class="form-group"
                                                 [class.required]="true">
                                                <label for="paisesDataList"
                                                       class="form-label">País de nacimiento</label>
                                                <input formControlName="paisNacimiento"
                                                       class="form-control"
                                                       (ngModelChange)="onChangePais($event)"
                                                       list="paises"
                                                       id="datalistPaisesDisponibles"
                                                       [placeholder]="'Escriba aquí para buscar...'"
                                                       [class.is-invalid]="paisNacimiento"
                                                       >
                                                <mat-error *ngIf="paisNacimiento"
                                                           class="text-danger">Ingrese un pais de
                                                    nacimiento</mat-error>
                                                <datalist id="paises">
                                                    <option *ngFor="let pais of paises"
                                                            [value]="pais.name_es">
                                                        {{pais.name_es}}
                                                    </option>
                                                </datalist>
                                            </div>

                                            <div class="form-group"
                                                 [class.required]="true">
                                                <label>Teléfono (WhatsApp)</label>
                                                <div class="input-group">
                                                    <input formControlName="telefono"
                                                           type="tel"
                                                           [placeholder]="'Ej: +54 11 1234 5678'"
                                                           class="form-control"
                                                           [class.is-invalid]="telefono"
                                                           >
                                                    <mat-error *ngIf="telefono"
                                                               class="text-danger">Ingrese un número de
                                                        WhatsApp válido</mat-error>
                                                </div>
                                            </div>

                                            <div class="form-group"
                                                 [class.required]="true">
                                                <mat-form-field appearance="fill"
                                                                [style.width.%]=100>
                                                    <label class="form-label">Sede</label>
                                                    <mat-select formControlName="signoSedes"
                                                                [class.is-invalid]="sede"
                                                                [disabled]="!sedes"
                                                                [(ngModel)]="selectedSede"
                                                                required>
                                                        <mat-option *ngFor="let sede of sedes"
                                                                    value="{{ sede._id }}">{{ sede.nombre
                                                            }}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="sede"
                                                               class="text-danger">Seleccione
                                                        una sede</mat-error>
                                                </mat-form-field>
                                            </div>

                                        </div>

                                    </div>

                                    <button [disabled]="!formAfiliado.valid"
                                            [ngClass]="{'custom-disabled': !formAfiliado.valid}"
                                            type="submit"
                                            class="animate__animated animate__fadeIn">GUARDAR</button>
                                    <button routerLink="/afiliados-listado"
                                            class="animate__animated animate__fadeIn">CANCELAR</button>
                                    <br>
                                    <br>
                                </form>
                            </ngx-tab>

                            <!-- Gestio Afiliado -->

                            <ngx-tab tabTitle="Gestión">
                                <form [formGroup]="formAfiliado"
                                      (ngSubmit)="onSubmit()">
                                    <div class="row">

                                        <div class="container overflow-hidden">
                                            <div class="row flex-row-m flex-row-l">
                                                <div class="alert alert-info">
                                                    <strong>¡Información!</strong> Si el usuario al que se
                                                    le cambia de <strong>Estado</strong> es titular, se le
                                                    cambiara el mismo a sus familiares. En el caso de
                                                    <u>suspensión</u>, si un familiar posee alguna clausula,
                                                    quedará excluido.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-6 col-md-6 col-sm-12 col">

                                            <div class="form-group"
                                                 [class.required]="true">
                                                <mat-form-field appearance="fill"
                                                                [style.width.%]=100>
                                                    <mat-label>Estado</mat-label>
                                                    <mat-select formControlName="estado"
                                                                [class.is-invalid]="estado">
                                                        <mat-option *ngFor="let estado of estados"
                                                                    [value]="estado">{{ estado }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="estado"
                                                               class="text-danger">Seleccione
                                                        un estado</mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="form-group">
                                                <mat-form-field color="accent"
                                                                appearance="fill"
                                                                [style.width.%]=100>
                                                    <mat-label>Fecha de Cobertura</mat-label>
                                                    <input formControlName="fechaCobertura"
                                                           matInput
                                                           [matDatepicker]="picker2"
                                                           autocomplete="off">
                                                    <mat-datepicker-toggle matSuffix
                                                                           [for]="picker2"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker2
                                                                    color="accent"></mat-datepicker>
                                                </mat-form-field>
                                            </div>

                                            <div class="container d-flex flex-column">

                                                <div class="form-group">
                                                    <div class="row d-flex p-3">
                                                        <mat-label>PMI</mat-label>
                                                        <mat-slide-toggle formControlName="pmi"
                                                                          [(ngModel)]="isPMI"
                                                                          (change)="updateValuesPMI($event.checked)"
                                                                          color="{{isPMI ? 'primary' : 'warn'}}">
                                                            {{isPMI ? 'Si' : 'No'}}
                                                        </mat-slide-toggle>
                                                    </div>
                                                </div>

                                                <div class="form-group">
                                                    <div class="row d-flex p-3">
                                                        <mat-label>Discapacidad</mat-label>
                                                        <mat-slide-toggle formControlName="discapacidad"
                                                                          [(ngModel)]="isDisability"
                                                                          (change)="updateValuesDisability($event.checked)"
                                                                          color="{{isDisability ? 'primary' : 'warn'}}">
                                                            {{isDisability ? 'Si' : 'No'}}
                                                        </mat-slide-toggle>
                                                    </div>
                                                </div>

                                                <div class="form-group">
                                                    <div class="row d-flex p-3">
                                                        <mat-label>Otras Cronicidades</mat-label>
                                                        <mat-slide-toggle formControlName="otrasCronicidades"
                                                                          [(ngModel)]="isChronicities"
                                                                          (change)="updateValuesChronicities($event.checked)"
                                                                          color="{{isChronicities ? 'primary' : 'warn'}}">
                                                            {{isChronicities ? 'Si' : 'No'}}
                                                        </mat-slide-toggle>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                        <div class="col-lg-6 col-md-6 col-sm-12 col">

                                            <div class="form-group">
                                                <mat-form-field color="warn"
                                                                appearance="fill"
                                                                [style.width.%]=100>
                                                    <mat-label>Fecha</mat-label>
                                                    <input formControlName="fechaVigencia"
                                                           matInput
                                                           [matDatepicker]="picker1"
                                                           [class.is-invalid]="fechaVigenciaNoValida"
                                                           autocomplete="off">
                                                    <mat-error *ngIf="fechaVigenciaNoValida">Ingrese una
                                                        fecha</mat-error>
                                                    <mat-datepicker-toggle matSuffix
                                                                           [for]="picker1"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker1
                                                                    color="warn"></mat-datepicker>
                                                </mat-form-field>
                                            </div>

                                            <div class="form-group">
                                                <mat-form-field color="accent"
                                                                appearance="fill"
                                                                [style.width.%]=100>
                                                    <mat-label>Fecha de Baja</mat-label>
                                                    <input formControlName="fechaBaja"
                                                           matInput
                                                           [matDatepicker]="picker3"
                                                           [class.is-invalid]="fechaNoValida"
                                                           autocomplete="off">
                                                    <mat-error *ngIf="fechaNoValida">Ingrese una
                                                        fecha</mat-error>
                                                    <mat-datepicker-toggle matSuffix
                                                                           [for]="picker3"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker3
                                                                    color="accent"></mat-datepicker>
                                                </mat-form-field>
                                            </div>

                                            <div class="form-group">
                                                <mat-form-field color="primary"
                                                                appearance="fill"
                                                                [style.width.%]=100>
                                                    <mat-label>Vencimiento PMI</mat-label>
                                                    <input formControlName="fechaVtoPMI"
                                                           matInput
                                                           [matDatepicker]="picker4"
                                                           autocomplete="off">
                                                    <mat-datepicker-toggle matSuffix
                                                                           [for]="picker4"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker4
                                                                    color="primary"></mat-datepicker>
                                                </mat-form-field>
                                            </div>

                                            <div class="form-group">
                                                <mat-form-field color="primary"
                                                                appearance="fill"
                                                                [style.width.%]=100>
                                                    <mat-label>Vencimiento Discapacidad</mat-label>
                                                    <input formControlName="fechaVtoDiscapacidad"
                                                           matInput
                                                           [matDatepicker]="picker5"
                                                           autocomplete="off">
                                                    <mat-datepicker-toggle matSuffix
                                                                           [for]="picker5"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker5
                                                                    color="primary"></mat-datepicker>
                                                </mat-form-field>
                                            </div>

                                            <div class="form-group">
                                                <mat-form-field color="primary"
                                                                appearance="fill"
                                                                [style.width.%]=100>
                                                    <mat-label>Vencimiento Otras Cronicidades</mat-label>
                                                    <input formControlName="fechaVtoOtrasCronicidades"
                                                           matInput
                                                           [matDatepicker]="picker6"
                                                           [class.is-invalid]="fechaNoValidaCronicidades"
                                                           autocomplete="off">
                                                    <mat-error *ngIf="fechaNoValidaCronicidades">Ingrese una
                                                        fecha de discapacidad</mat-error>
                                                    <mat-datepicker-toggle matSuffix
                                                                           [for]="picker6"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker6
                                                                    color="primary"></mat-datepicker>
                                                </mat-form-field>
                                            </div>

                                        </div>

                                    </div>

                                    <button [disabled]="!formAfiliado.valid"
                                            [ngClass]="{'custom-disabled': !formAfiliado.valid}"
                                            type="submit"
                                            class="animate__animated animate__fadeIn">GUARDAR</button>

                                    <button routerLink="/afiliados-listado"
                                            class="animate__animated animate__fadeIn">CANCELAR</button>
                                </form>
                            </ngx-tab>
                        </ngx-tabset>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>